import React, { useEffect, useState, useContext } from 'react'
import SideBar from './SideBar'
import { Outlet, Navigate, useLocation, useNavigate } from 'react-router-dom'
import AuthContext from '../../middlewares/AuthContext'
import axios from 'axios'

const url = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_URL
  : process.env.REACT_APP_URL_DEV

interface AuthCtx {
  token     : string | null
  getHeaders: () => Promise<Record<string, string>>
  onLogout  : () => void
}

const ENV_BADGE: Record<string, string> = {
  qa          : 'QA',
  development : 'DEV',
}

const Main: React.FC = () => {
  const { token, getHeaders, onLogout } = useContext(AuthContext) as AuthCtx
  const [flip, setFlip]   = useState(false)
  const location          = useLocation()
  const navigate          = useNavigate()

  const validateToken = async () => {
    try {
      const headers = await getHeaders()
      await axios.get(`${url}auth/validate`, { headers })
    } catch {
      await onLogout()
      navigate('/auth/login', { state: { from: location } })
    }
  }

  const showNavbar = (toggleId: string, navId: string, bodyId: string, headerId: string) => {
    setFlip(prev => !prev)
    const nav      = document.getElementById(navId)
    const bodypd   = document.getElementById(bodyId)
    const headerpd = document.getElementById(headerId)
    if (nav && bodypd && headerpd) {
      nav.classList.toggle('nav_show')
      bodypd.classList.toggle('body-pd2')
      headerpd.classList.toggle('body-pd')
    }
  }

  const markActiveLinks = () => {
    const links = document.querySelectorAll<HTMLElement>('.nav_link')

    links.forEach(link => {
      const href = link.getAttribute('href')
      if (href && location.pathname.includes(href)) {
        link.classList.add('active')
      }
      link.addEventListener('click', () => {
        links.forEach(l => l.classList.remove('active'))
        link.classList.add('active')
      })
    })
  }

  useEffect(() => {
    markActiveLinks()
    validateToken()
  }, [])

  if (!token) {
    return <Navigate to="/auth/login" state={{ from: location }} />
  }

  const env     = process.env.REACT_APP_ENV ?? ''
  const envLabel = ENV_BADGE[env]

  return (
    <div id="body-pd">

      {envLabel && (
        <div style={{
          position        : 'fixed',
          bottom          : '1rem',
          right           : '1rem',
          zIndex          : 9999,
          backgroundColor : '#dc3545',
          color           : '#fff',
          fontWeight      : 700,
          fontSize        : '0.72rem',
          padding         : '4px 12px',
          borderRadius    : 9999,
          letterSpacing   : '0.06em',
          boxShadow       : '0 2px 8px rgba(220,53,69,0.4)',
          opacity         : 0.9,
          pointerEvents   : 'none',
        }}>
          {envLabel}
        </div>
      )}

      <SideBar showNavbar={showNavbar} flip={flip} />

      <main style={{ marginTop: '4rem' }}>
        <Outlet />
      </main>

    </div>
  )
}

export default Main
